import { useId } from 'react';
import { Dialog } from '@headlessui/react';
import { VacationPaidRestHistoryPanel } from './VacationPaidRestHistoryPanel';
import type { VacationPaidRestHistoryModalProps } from './vacationPaidRestHistoryModal.types';

export function VacationPaidRestHistoryModal({
    row,
    isOpen,
    onClose,
}: VacationPaidRestHistoryModalProps) {
    const titleId = useId();

    if (!isOpen || !row) return null;

    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-50" aria-labelledby={titleId}>
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

            <div className="fixed inset-0 flex items-center justify-center p-4">
                <Dialog.Panel className="w-full max-w-2xl rounded-2xl bg-white shadow-xl overflow-hidden flex flex-col max-h-[90vh]">
                    <VacationPaidRestHistoryPanel row={row} titleId={titleId} onClose={onClose} />
                </Dialog.Panel>
            </div>
        </Dialog>
    );
}
